// Real data for RCD (Rajdhani Crafts and Daughters Pvt. Ltd.)
// Sourced from public records: LinkedIn, Tofler, MCA and official channels.

export const CLIENTS = [
  // Assets provided by the client team
  {
    name: 'Godrej',
    logo: 'https://customer-assets-39nsmqrw.emergentagent.net/job_b191b3f8-8c80-4626-9a83-dd796a8bbc8c/artifacts/oe3f23nq_godrej-logo-godrej-icon-free-free-vector.jpg',
    type: 'image'
  },
  {
    name: 'Taj Sawai Ranthambore',
    logo: 'https://customer-assets-39nsmqrw.emergentagent.net/job_b191b3f8-8c80-4626-9a83-dd796a8bbc8c/artifacts/w8csm4bc_Taj%20Logo.JPG',
    type: 'image'
  },
  {
    name: 'The Gateway Hotels & Resorts',
    logo: 'https://customer-assets-39nsmqrw.emergentagent.net/job_b191b3f8-8c80-4626-9a83-dd796a8bbc8c/artifacts/m9zrf7no_the-gateway-resort-damdama-lake-logo.jpg',
    type: 'image'
  },
  // Publicly referenced RCD client roster
  { name: 'Taj Hotels', logo: 'TAJ', type: 'text' },
  { name: 'Hyatt', logo: 'HYATT', type: 'text' },
  { name: 'Marriott', logo: 'Marriott', type: 'text' },
  { name: 'Alila', logo: 'ALILA', type: 'text' },
  { name: 'ITC Hotels', logo: 'ITC HOTELS', type: 'text' },
  { name: 'Yak & Yeti', logo: 'YAK & YETI', type: 'text' }
];

export const PRODUCT_CATEGORIES = [
  {
    id: 'lounge',
    name: 'Lounge & Lobby Seating',
    tagline: 'Statement pieces for grand arrivals',
    description: 'Bespoke sofas, accent chairs, and lounge sets crafted in velvet, leather and hand-loomed textiles that define first impressions.',
    image: 'https://images.unsplash.com/photo-1759038086832-795644825e3a',
    items: ['Modular Sofas', 'Wingback Chairs', 'Ottomans', 'Chesterfields', 'Bench Seating']
  },
  {
    id: 'guestroom',
    name: 'Guestroom Suites',
    tagline: 'Sanctuary in every stitch',
    description: 'Custom-built beds, headboards, wardrobes and writing desks — engineered for hospitality durability without compromising warmth.',
    image: 'https://images.unsplash.com/photo-1731336478850-6bce7235e320',
    items: ['Upholstered Headboards', 'Bed Frames', 'Nightstands', 'Wardrobes', 'Study Desks']
  },
  {
    id: 'dining',
    name: 'Dining & Banquet',
    tagline: 'Where hospitality gathers',
    description: 'Solid-wood dining tables, sculpted chairs and banquet suites that stand up to daily service and stand out for a lifetime.',
    image: 'https://images.unsplash.com/photo-1712063680618-c1883afb1a5a',
    items: ['Dining Tables', 'Banquet Chairs', 'Bar Stools', 'Consoles', 'Buffet Cabinets']
  },
  {
    id: 'flooring',
    name: 'Engineered Wooden Flooring',
    tagline: 'Grounded elegance',
    description: 'Premium engineered wood plank and parquet flooring — pre-finished, humidity-stable and delivered project-ready.',
    image: 'https://images.unsplash.com/photo-1655516433028-9e0e1599cf8b',
    items: ['Oak Planks', 'Walnut Parquet', 'Herringbone', 'Chevron', 'Custom Inlays']
  },
  {
    id: 'heritage',
    name: 'Heritage & Palace Craft',
    tagline: 'Rajasthan artistry, reimagined',
    description: 'Hand-carved doors, jharokhas, and marquetry pieces created in Jaipur ateliers for palace hotels and heritage resorts.',
    image: 'https://images.pexels.com/photos/33803745/pexels-photo-33803745.jpeg',
    items: ['Carved Doors', 'Jharokhas', 'Screens', 'Inlay Panels', 'Bespoke Millwork']
  },
  {
    id: 'outdoor',
    name: 'Outdoor & Poolside',
    tagline: 'Weathered gracefully',
    description: 'Teak, powder-coated aluminium and all-weather rope furniture designed for verandahs, pool decks and open-air dining.',
    image: 'https://images.unsplash.com/photo-1648960456182-00643d5d20eb',
    items: ['Sun Loungers', 'Deep Seating', 'Cabanas', 'Garden Dining', 'Planters']
  }
];

export const PROJECTS = [
  {
    id: 1,
    name: 'Taj Sawai — Ranthambore',
    category: 'Heritage Resort',
    location: 'Rajasthan, India',
    scope: 'Full guestroom furniture, restaurant seating & lobby lounge',
    image: 'https://images.pexels.com/photos/33803745/pexels-photo-33803745.jpeg',
    year: '2024'
  },
  {
    id: 2,
    name: 'The Gateway Resort',
    category: 'Leisure Resort',
    location: 'Damdama Lake, Haryana',
    scope: 'Villa interiors, poolside cabanas & banquet furniture',
    image: 'https://images.unsplash.com/photo-1677129667171-92abd8740fa3',
    year: '2023'
  },
  {
    id: 3,
    name: 'Godrej Properties',
    category: 'Residential Project',
    location: 'Multi-city, India',
    scope: 'Sample apartment furnishings & club-house lounge fit-out',
    image: 'https://images.unsplash.com/photo-1759038086832-795644825e3a',
    year: '2024'
  },
  {
    id: 4,
    name: 'Palace Boutique Hotel',
    category: 'Heritage Boutique',
    location: 'Udaipur, India',
    scope: 'Hand-carved doors, jharokhas & suite furniture',
    image: 'https://images.unsplash.com/photo-1655516433028-9e0e1599cf8b',
    year: '2023'
  },
  {
    id: 5,
    name: 'Lakeside Wellness Retreat',
    category: 'Wellness Resort',
    location: 'Kerala, India',
    scope: 'Spa cabana furniture & guestroom suites',
    image: 'https://images.unsplash.com/photo-1648960456182-00643d5d20eb',
    year: '2024'
  },
  {
    id: 6,
    name: 'Metropolitan Business Hotel',
    category: 'Business Hotel',
    location: 'Bengaluru, India',
    scope: 'All-day dining, executive lounge & meeting suites',
    image: 'https://images.unsplash.com/photo-1712063680618-c1883afb1a5a',
    year: '2022'
  }
];

export const STATS = [
  { value: '1964', label: 'Family legacy begins' },
  { value: '9', label: 'Export countries' },
  { value: '6+', label: 'Named hotel groups' }
];

export const EXPORT_COUNTRIES = [
  { name: 'Jaipur, India', short: 'India', label: 'Headquarters', x: 71.1, y: 35, home: true, flag: 'https://flagcdn.com/w160/in.png' },
  { name: 'United States', short: 'USA', label: 'Export Market', x: 22, y: 30, tagX: 22, tagY: 18, flag: 'https://flagcdn.com/w160/us.png' },
  { name: 'Canada', short: 'Canada', label: 'Export Market', x: 26, y: 22, tagX: 26, tagY: 10, flag: 'https://flagcdn.com/w160/ca.png' },
  { name: 'United Kingdom', short: 'UK', label: 'Export Market', x: 49.5, y: 22, tagX: 39, tagY: 8, flag: 'https://flagcdn.com/w160/gb.png' },
  { name: 'Netherlands', short: 'Netherlands', label: 'Export Market', x: 51.4, y: 21, tagX: 49, tagY: 2, flag: 'https://flagcdn.com/w160/nl.png' },
  { name: 'Belgium', short: 'Belgium', label: 'Export Market', x: 51.1, y: 23, tagX: 43, tagY: 34, flag: 'https://flagcdn.com/w160/be.png' },
  { name: 'Germany', short: 'Germany', label: 'Export Market', x: 53.6, y: 21, tagX: 63, tagY: 8, flag: 'https://flagcdn.com/w160/de.png' },
  { name: 'France', short: 'France', label: 'Export Market', x: 49, y: 25, tagX: 33, tagY: 22, flag: 'https://flagcdn.com/w160/fr.png' },
  { name: 'Spain', short: 'Spain', label: 'Export Market', x: 48.5, y: 28, tagX: 32, tagY: 36, flag: 'https://flagcdn.com/w160/es.png' },
  { name: 'South Africa', short: 'South Africa', label: 'Export Market', x: 55, y: 68, tagX: 55, tagY: 80, flag: 'https://flagcdn.com/w160/za.png' }
];

export const OFFERINGS = [
  {
    id: 'export',
    tag: 'Global Export',
    name: 'Export Solutions',
    description: 'Container-ready furniture built to global specifications with FSC-tracked timber, contract-grade finishes and full logistics support across 8 countries.',
    highlights: ['FSC-certified sourcing', 'Container consolidation', 'Export documentation', 'On-site install teams'],
    image: 'https://images.unsplash.com/photo-1605745341112-85968b19335b?w=1600&auto=format&fit=crop&q=80'
  },
  {
    id: 'hotel',
    tag: 'Hospitality',
    name: 'Hotel & Resort Interiors',
    description: 'Guestroom suites, banquet halls, lobby lounges and all-day dining — designed for high-turn hospitality without compromising warmth.',
    highlights: ['Palace & heritage hotels', 'Boutique retreats', 'Business hotels', 'Restaurants & F&B'],
    image: 'https://images.unsplash.com/photo-1677129667171-92abd8740fa3'
  },
  {
    id: 'retail',
    tag: 'Retail',
    name: 'Retail & Showroom Fit-outs',
    description: 'Statement retail environments, showroom displays and hospitality-inspired residential clubhouses that convert footfall into conversation.',
    highlights: ['Flagship stores', 'Brand showrooms', 'Clubhouses', 'Experience centres'],
    image: 'https://images.unsplash.com/photo-1759038086832-795644825e3a'
  },
  {
    id: 'flooring',
    tag: 'Flooring',
    name: 'Engineered Wooden Flooring',
    description: 'Premium engineered wood plank and parquet flooring — pre-finished, humidity-stable and delivered project-ready in oak, walnut and custom species.',
    highlights: ['Oak & Walnut planks', 'Herringbone & Chevron', 'Custom inlays', 'Pre-finished delivery'],
    image: 'https://images.unsplash.com/photo-1655516433028-9e0e1599cf8b'
  }
];

export const CAPABILITIES = [
  { title: 'Design & Technical Development', desc: 'We study approved concepts, drawings, specifications and BOQs to resolve materials, construction, dimensions and manufacturing details before full production begins.' },
  { title: 'In-house Manufacturing', desc: 'RCD\u2019s Jaitpura and Bassi units provide a combined operational floor area of 1,44,000 sq. m., bringing timber processing, joinery, metalwork, upholstery, flooring, finishing and packing into one integrated manufacturing operation.' },
  { title: 'Global Exports', desc: 'Manufacturing is aligned to international client specifications and supported by export packing, container programmes and shipment coordination for worldwide delivery.' },
  { title: 'Custom Manufacturing', desc: 'Furniture, fixtures and engineered wood flooring are developed around each client\u2019s drawings, specifications, materials, dimensions and finish requirements.' }
];

export const TESTIMONIALS = [];

export const FOUNDER = {
  isPair: true,
  title: 'Family Leadership',
  sharedPhoto: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/658jqxhg_IMG_7707.webp',
  intro: 'From the family\u2019s sawmill in Jhunjhunu to today\u2019s manufacturing operation in Jaipur, three generations of the Agarwal family have shaped the enterprise through different responsibilities and a shared knowledge of wood and making.',
  directors: [
    {
      name: 'Mr. Samir Agarwal',
      title: 'Managing Director',
      bio: 'Samir Agarwal joined the family business in 1982. In 1993, he moved the enterprise to Jaipur and led its transition from sawmilling into furniture manufacturing, later developing its export business and strengthening the production and commercial base on which RCD operates today.',
      image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/658jqxhg_IMG_7707.webp'
    },
    {
      name: 'Poorvi Agarwal',
      title: 'Director',
      bio: 'Poorvi Agarwal leads business development, key relationships and brand at RCD. Her work connects the company\u2019s manufacturing capabilities with hotel groups, designers, architects and procurement teams, while shaping how RCD presents its experience, capabilities and contemporary direction.',
      image: 'https://images.unsplash.com/photo-1631396326646-c06a935ff3a6'
    },
    {
      name: 'Sakshi Agarwal',
      title: 'Director',
      bio: 'Sakshi Agarwal leads operations, product development and export execution at RCD. She connects project requirements with development and production, coordinating the practical demands of domestic and international orders from brief through delivery.',
      image: 'https://images.pexels.com/photos/31567149/pexels-photo-31567149.jpeg'
    }
  ],
  legacyNote: 'The words \u201c& Daughters\u201d make a handover visible. Poorvi and Sakshi are present in the company\u2019s identity because they are present in its leadership \u2014 deciding how the family\u2019s knowledge, capabilities and relationships should be carried forward.',
  quote: 'The name came when they were ready to lead.'
};

export const PLANT_INFO = {
  intro: 'RCD\u2019s Jaitpura and Bassi units connect timber preparation, wood processing, veneer, boards, metalwork, upholstery, flooring, finishing and packing through one coordinated manufacturing operation, providing closer control over quality and delivery planning.',
  tourVideo: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/kybznbpj_RCD%20LAKKAD%20GHARANA%20FACTORY%20TOUR%20VIDEO%20SHORT%20VIDEO.mp4',
  locations: [
    { name: 'Jaitpura', region: 'Near Jaipur, Rajasthan' },
    { name: 'Bassi', region: 'Near Jaipur, Rajasthan' }
  ],
  floorArea: '1,44,000 Sq. Mtr.',
  machinery: [
    { name: 'Beam Saw (KDT KS 832)', image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/0mcvjdft_BEAM%20SAW%20%281%29.webp' },
    { name: 'Cutting & Shaping Line', image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/pvtsunmd_CUTTING%20MACHINE%20%281%29.webp' },
    { name: 'Beam Saw (KV)',        image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/w2bhunr6_BEAM%20SAW%20%2816%29.webp' },
    { name: 'Edge Banding (BOSSE)', image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/ccfgyck8_EDGE%20BANDING%20%282%29.webp' },
    { name: 'Hot Press (NIHAR NR-113)', image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/qep0dbi7_HOT%20PRESS%20%281%29.webp' },
    { name: 'Panel Saw (HUAHUA)',   image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/ed17ge4b_PANNEL%20SAW%20%281%29.webp' },
    { name: 'Precision Panel Saw (MJK 1132F1)', image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/x8wgr3ao_PRECISION%20PANNEL%20SAW%20%282%29.webp' },
    { name: 'Precision Panel Saw (Nanxing MJB 1328B)', image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/76evuvrb_ROUTER%20MACHINE%20%284%29.webp' },
    { name: 'Spindle Moulder (Chen Sheng)', image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/l8qvodm5_MINI%20FIX%20MACHINE%20%285%29.webp' },
    { name: 'Slicer Joint Machine (Innovator)', image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/auvf2p6g_SLICER%20JOINT%20MACHINE%20%283%29.webp' },
    { name: 'Top Joint Machine (KUOMING)', image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/8hqk43mp_TOP%20JOINT%20MACHINE%20%286%29.webp' },
    { name: 'Panel Saw (INOVANCE)', image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/fhix9co0_PANNEL%20SAW%20%288%29.webp' }
  ]
};

export const HISTORY_TIMELINE = [
  { year: '1964', title: 'Timber becomes the foundation', desc: 'The family establishes a sawmill in Jhunjhunu, Rajasthan, and begins sourcing timber \u2014 a division of the business that remains active and continues to expand today.' },
  { year: '1982', title: 'Samir Agarwal joins the business', desc: 'Working within the family enterprise, he builds the experience that would guide its move from sawmilling into finished furniture.' },
  { year: '1993', title: 'Furniture manufacturing begins in Jaipur', desc: 'Samir Agarwal moves the business to Jaipur and leads its transition from a sawmill-led operation into furniture manufacturing.' },
  { year: '2021', title: 'Rajdhani Crafts & Daughters is established', desc: 'Poorvi and Sakshi Agarwal establish Rajdhani Crafts and Daughters Pvt. Ltd., giving formal identity to the leadership transition they had prepared for by learning the business from within.' },
  { year: '2022', title: 'A dedicated hospitality vertical', desc: 'RCD launches its Hotel Catalogue, formalising its expansion into bespoke, project-based manufacturing for luxury hospitality.' },
  { year: '2023', title: 'A growing roster of hospitality leaders', desc: 'By 2023, RCD\u2019s hospitality portfolio includes Taj, Hyatt, Marriott, Alila, ITC and Yak & Yeti \u2014 expanding this new vertical alongside its established export business.' },
  { year: 'Today', title: 'Manufacturing across two Jaipur units', desc: 'RCD develops and manufactures furniture, fixtures and engineered wood flooring through connected departments at its Jaitpura and Bassi units.' }
];

export const PRODUCT_TABS = [
  {
    id: 'export',
    tag: 'Global Export',
    name: 'Global Export',
    tagline: 'Made in Jaipur, delivered worldwide',
    video: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/y006hp40_Global%20Export.mp4',
    description: 'RCD manufactures furniture for international buyers across seven export markets. From technical development and production to quality control, packing, documentation and dispatch, every stage is coordinated by the team in Jaipur.',
    highlights: [
      'Legal timber sourcing & geographic-origin traceability',
      'Container consolidation & pack lists',
      'Export documentation & compliance',
      'Buyer-specified testing & compliance coordination',
      'Custom crating & protective export packing',
      'Supply across North American, European & African markets',
      'Multi-container project management'
    ],
    stats: [{ v: '7', l: 'Export countries' }, { v: 'B2B', l: 'Global supply' }],
    categories: [
      {
        name: 'Solid Wood',
        desc: 'Sheesham, mango, teak & oak \u2014 procured through legal, documented routes from Government of India sources and government-approved farmers; seasoned and processed in-house before joinery.',
        image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/0x11q5ro_Solid%20wood.webp'
      },
      {
        name: 'Veneer',
        desc: 'Sliced, stitched and pasted in-house at 0.8 mm to 5 mm \u2014 walnut, oak, smoked eucalyptus book-matched onto stable engineered cores.',
        image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/kz6hkx9i_Veneer.JPG'
      },
      {
        name: 'HPL',
        desc: 'High-pressure laminate bonded to stable cores for contract-grade use \u2014 plyboards and pinewood blockboards also produced in-house.',
        image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/iok8usbp_HPL.jpg'
      },
      {
        name: 'Metal',
        desc: 'MS, SS & brass fabrication for frames, legs and hardware \u2014 with powder coating managed in-house for closer control over finish and timing.',
        image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/nglxs2yo_Metal.jpg'
      }
    ]
  },
  {
    id: 'hotels',
    tag: 'Hotels',
    name: 'Hotels',
    tagline: 'Where a hotel becomes a memory',
    video: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/fkieetk2_FOR%20WEBSITE%20HOTEL%20PROJECTS%20SHORT%20REEL.mp4',
    description: 'RCD manufactures guestroom suites, banquet furniture, lobby lounges and all-day dining furniture for hospitality projects. Each programme is developed around the property\u2019s approved design language, operational requirements, key count and delivery schedule.',
    highlights: [
      'Custom guestroom suites & headboards',
      'Restaurant, bar & banquet furniture',
      'Lobby lounges & club seating',
      'FF&E project management',
      'Millwork, wardrobes & vanities',
      'Spa & wellness cabinetry',
      'Outdoor & poolside furniture',
      'Heritage carving & inlay work',
      'Production planning for full-hotel roll-outs'
    ],
    stats: [{ v: 'B2B', l: 'Hospitality supplier' }, { v: 'Bespoke', l: 'Project-based' }],
    projects: [
      {
        title: 'Taj Damdama',
        location: 'Damdama Lake, Haryana',
        video: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/yjfi6o7s_TAJ%20DAM%20DMA.mp4'
      },
      {
        title: 'Taj Tree of Life',
        location: 'Mumbai, India',
        video: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/f0fc7fh3_TAJ%20TREE%20MUMBAI.mp4'
      },
      {
        title: 'Yny Hotel',
        location: 'India',
        video: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/gksjpe91_Yny%20Hotel%20Video.mp4'
      },
      {
        title: 'The Lalit Bagh Hotel',
        location: 'India',
        video: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/nis8w05i_LALIT%20BAGH%20HOTEL.mp4'
      },
      {
        title: 'Marriott Hotel',
        location: 'India',
        video: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/yy7lu65x_Marriott%20Hotel%20Reel-1_1.mp4'
      },
      {
        title: 'Swastik Resort',
        location: 'Rajasthan, India',
        video: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/ppd1cepo_Swastik%20Resort%20Short%20Reel-1.mp4'
      }
    ]
  },
  {
    id: 'retails',
    tag: 'Retails & Institution',
    name: 'Retails & Institution',
    tagline: 'Interiors that convert & endure',
    video: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/95316k97_Retails%20%26%20Institution.mp4',
    description: 'RCD manufactures fixtures, furniture and joinery for flagship stores, brand showrooms, corporate campuses and institutional environments, developing each element around the appearance, function, durability and repeatability required by the space.',
    highlights: [
      'Flagship retail fit-outs',
      'Brand showrooms & experience centres',
      'Fixtures, displays & millwork',
      'Roll-outs across multiple stores',
      'Corporate office furniture',
      'Auditorium & seminar seating',
      'Educational & institutional joinery',
      'Reception & lounge fit-outs',
      'Modular workstations & storage'
    ],
    stats: [{ v: 'Custom', l: 'Fit-outs' }, { v: 'Multi-store', l: 'Rollouts' }],
    slideshow: [
      {
        name: 'Residential Projects',
        caption: 'Private homes & villa fit-outs',
        cover: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/p0jh8lt9_Post%3D1%20%285%29.jpg',
        articles: [
          { image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/p0jh8lt9_Post%3D1%20%285%29.jpg', title: 'Bouclé Lobby Chair',      caption: 'Sculpted ivory bouclé armchair with walnut side table' },
          { image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/9u0xtg10_Post%3D2%20%282%29.jpg', title: 'C-Side Table Pair',       caption: 'Marble-topped C-tables in dark walnut beside a linen sofa' },
          { image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/laibt00k_Post%3D3%20%284%29.jpg', title: 'Reading Room Swivel',     caption: 'Rose bouclé swivel with brass reading lamp — private library' },
          { image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/k6p0q8u7_Post%3D4%20%283%29.jpg', title: 'Study Ottoman',           caption: 'Mustard velvet ottoman & backrest paired with a walnut desk' },
          { image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/h0l32vtq_Post%3D4%20%287%29.jpg', title: 'Bolster Chair Pair',      caption: 'Mustard bolster chairs with a copper-base marble table' }
        ]
      },
      {
        name: 'Events Projects',
        caption: 'Weddings, exhibitions & set design',
        cover: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/8h9ubfpf_1%20%286%29.JPG.jpg',
        articles: [
          { image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/8h9ubfpf_1%20%286%29.JPG.jpg', title: 'Cocktail Side Table',    caption: 'Black-and-gold gallery-top side table at a garden wedding' },
          { image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/6xobgwl3_2%20%2813%29.JPG.jpg', title: 'Reception Lounge',     caption: 'Curved velvet sofa with a champagne-gilt cocktail table' },
          { image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/98y54ur9_3%20%288%29.JPG.jpg',  title: 'Mandap Coffee Table',  caption: 'Black-lacquer coffee table with gilded feet — wedding stage' },
          { image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/gltuz98x_6%20%2813%29.JPG.jpg', title: 'Outdoor Velvet Sofa',  caption: 'Teal velvet three-seater beneath a floral canopy reception' },
          { image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/k2sue5bx_7%20%287%29.JPG.jpg',  title: 'Bouclé Accent Chair',  caption: 'Grey-frame ivory bouclé chair for event lounges' }
        ]
      },
      {
        name: 'Others Institutions',
        caption: 'Corporate, education & hospitality',
        cover: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/sol0zrim_10.jpeg.jpg',
        articles: [
          { image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/sol0zrim_10.jpeg.jpg', title: 'Executive Home Desk',   caption: 'Oak-top steel-frame desk with leather mat & brass lamp' },
          { image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/852givr0_12.jpeg.jpg', title: 'Managed Workspace',    caption: 'Two-drawer desk in a sage-toned managed workspace' },
          { image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/7ra3bnul_2%20%2814%29.jpeg.jpg', title: 'Walnut Writing Desk', caption: 'Four-drawer solid-walnut writing desk — front elevation' },
          { image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/zehzsr6n_2%20%2815%29.jpeg.jpg', title: 'Walnut Desk (open)',  caption: 'Same desk — three-quarter view with drawers extended' }
        ]
      },
      {
        name: 'Gifting Projects',
        caption: 'Bespoke corporate gifting & keepsakes',
        cover: 'https://images.unsplash.com/photo-1607344645866-009c320b63e0?w=1400&auto=format&fit=crop&q=85',
        articles: [
          { image: 'https://images.unsplash.com/photo-1607344645866-009c320b63e0?w=1400&auto=format&fit=crop&q=85', title: 'Sheesham Keepsake Box', caption: 'Dovetail-jointed box with hand-turned knob' },
          { image: 'https://images.unsplash.com/photo-1544816155-12df9643f363?w=1400&auto=format&fit=crop&q=85',    title: 'Signature Hamper',      caption: 'Layered wooden hamper for corporate diwali sets' },
          { image: 'https://images.unsplash.com/photo-1607346256330-dee7af15f7c5?w=1400&auto=format&fit=crop&q=85', title: 'Presentation Case',     caption: 'Velvet-lined walnut case for premium clientele' },
          { image: 'https://images.unsplash.com/photo-1512909006721-3d6018887383?w=1400&auto=format&fit=crop&q=85', title: 'Desk Set',              caption: 'Pen tray & letter block in solid mango wood' },
          { image: 'https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?w=1400&auto=format&fit=crop&q=85', title: 'Table Accessories',     caption: 'Coaster set with brass inlay' },
          { image: 'https://images.unsplash.com/photo-1549465220-1a8b9238cd48?w=1400&auto=format&fit=crop&q=85',    title: 'Curated Gift Trunk',    caption: 'Nested trunk of hand-selected artisan pieces' }
        ]
      }
    ]
  },
  {
    id: 'flooring',
    tag: 'Engineered Wooden Flooring',
    name: 'Engineered Wooden Flooring',
    tagline: 'Grounded elegance',
    video: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/41omok00_Wooden%20flooring.mp4',
    description: 'RCD manufactures engineered wood plank and parquet flooring in oak, walnut and selected species, with the format, pattern, colour and surface finish developed around the intended interior.',
    highlights: [
      'Oak & Walnut engineered planks',
      'Herringbone & Chevron parquet',
      'Custom inlays & border patterns',
      'Pre-finished, project-ready delivery',
      'UV-cured lacquer & oil finishes',
      'Wide-plank & long-board options',
      'Custom species & finish development'
    ],
    stats: [{ v: 'Custom', l: 'Species & finish' }, { v: 'Ready', l: 'Project delivery' }],
    slideshow: [
      { image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/flxbhyb6_pexels-amar-8389901.webp',                    title: 'Suite Lounge Floor',      caption: 'Wide-plank engineered oak beneath a mid-century lounge' },
      { image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/7df99t6p_pexels-cafepolverini-10911208.webp',         title: 'Sunlit Kitchen Plank',    caption: 'Rustic oak plank catching morning light' },
      { image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/vui7b1i5_pexels-curtis-adams-1694007-3935327.webp',   title: 'Residence Install',       caption: 'Full-home hardwood in warm honey tones' },
      { image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/xk94i4yy_pexels-designecologist-15226296.webp',       title: 'Studio Wide-Plank',       caption: 'Distressed oak plank in a minimal room' },
      { image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/biqkono0_pexels-digitalbuggu-230776.webp',            title: 'Grain Detail',            caption: 'Close-up: light oak with soft grain movement' },
      { image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=900&auto=format&fit=crop&q=85',                                     title: 'Wide Oak Plank',          caption: 'Natural oak, brushed & matte-lacquered' },
      { image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=900&auto=format&fit=crop&q=85',                                     title: 'Living-room Install',     caption: 'Wide-plank engineered oak, honey stain' },
      { image: 'https://images.unsplash.com/photo-1618220179428-22790b461013?w=900&auto=format&fit=crop&q=85',                                     title: 'Suite Bedroom Floor',     caption: 'Wide-plank walnut with satin lacquer' },
      { image: 'https://images.unsplash.com/photo-1449247709967-d4461a6a6103?w=900&auto=format&fit=crop&q=85',                                     title: 'Rustic Oak',              caption: 'Reactive-stain finish, character grade' }
    ]
  }
];

export const HERO_VIDEO = 'https://customer-assets-rejwkqb3.emergentagent.net/job_rcd-clients/artifacts/20ig65h9_5.mp4';

export const CONTACT_INFO = {
  address: 'Khasra No. 1955–1965, Near 6km Milestone, Jaitpura, Jaipur, Rajasthan 303704, India',
  phone: '+91 92518 54963',
  email: 'info@thercd.in',
  hours: 'Mon – Sat, 10:00 – 18:30 IST',
  socials: {
    instagram: 'https://www.instagram.com/rajdhanicraftsanddaughters',
    linkedin: 'https://www.linkedin.com/company/rajdhani-crafts-and-daughters-private-limited/',
    youtube: 'https://www.youtube.com/@Rajdhanicraftsanddaughters-B2B'
  }
};
